import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

// Unified filter pill — neutral hairline + subtle brand-green hover.
// Was wearing its own green tint that made the four filter buttons
// look like four separate UI lights instead of one filter row.
const useStyles = makeStyles((theme) => {
	const isDark = theme.palette.type === "dark";
	return {
		selectButton: {
			backgroundColor: isDark ? "#131614" : "#fff",
			borderRadius: 10,
			transition: "border-color 0.18s ease, background-color 0.18s ease",
			"&:hover": {
				backgroundColor: isDark
					? "rgba(46, 227, 122, 0.06)"
					: "rgba(37, 211, 102, 0.06)",
			},
			"& .MuiSelect-outlined": {
				paddingTop: 8,
				paddingBottom: 8,
				paddingLeft: 14,
				paddingRight: 32,
				fontSize: 13,
				fontWeight: 600,
				color: isDark ? "#e4e4e7" : "#0f172a",
			},
			"& .MuiSelect-icon": {
				color: isDark ? "#a8acb3" : "#64748b",
			},
			"& .MuiOutlinedInput-notchedOutline": {
				borderWidth: 1,
				borderColor: isDark
					? "rgba(255, 255, 255, 0.07)"
					: "#eaeaea",
			},
			"&:hover .MuiOutlinedInput-notchedOutline": {
				borderColor: isDark
					? "rgba(46, 227, 122, 0.4)"
					: "#86efac",
			},
		},
	};
});

export function UsersFilter({ onFiltered, initialUsers }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const [users, setUsers] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await loadUsers();
    }
    fetchData();
  }, []);

  useEffect(() => {
    setSelecteds([]);
    if (
      Array.isArray(initialUsers) &&
      Array.isArray(users) &&
      users.length > 0
    ) {
      onChange(initialUsers);
    }
  }, [initialUsers, users]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadUsers = async () => {
    try {
      const { data } = await api.get(`/users/list`);
      const userList = data.map((u) => ({ id: u.id, name: u.name }));
      setUsers(userList);
    } catch (err) {
      toastError(err);
    }
  };

  const handleChange = async (event) => {
    const { value } = event.target;
    setSelecteds(value);
    onFiltered(value);
  };

  const onChange = async (value) => {
    setSelecteds(value);
    onFiltered(value);
  };
  return (
    <Box style={{ paddingRight: 5 }}>
      <FormControl fullWidth margin="dense">
        <Select
          multiple
          className={classes.selectButton}
          displayEmpty
          variant="outlined"
          value={selecteds}
          onChange={handleChange}
          renderValue={(selected) => {
            // if (selected.length === 0) {
              return <em>{t("mainDrawer.listItems.users")}</em>;
            // }
            // return selected.map((id) => users.find((user) => user.id === id).name).join(", ");
          }}
          MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
        >
          {users.length > 0 &&
            users.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                <Checkbox
                  style={{
                    color: "#bfbfbf",
                  }}
                  size="small"
                  color="primary"
                  checked={selecteds.indexOf(user.id) > -1}
                />
                <ListItemText primary={user.name} />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default UsersFilter;
